<style>
    table {
        border: 1px solid gainsboro;
        width: 100%;
        border-collapse: collapse;
    }

    th {
        background-color: aliceblue;
        color: black;
        padding: 10px;
        border: 1px solid gainsboro;
    }

    td {
        padding: 10px;
        border: 1px solid gainsboro;
    }
</style>

<script>
    import {onMount} from 'svelte'
    import * as Common from '../Common.js'

    let reports = []
    onMount(async () => {
        Common.getData('reports')
        .then(data => {
            reports = data
        })
    })

    function createLink(type, id) {
        if(type === Common.REPORTTYPE_ITEM) {
            return '<a href="#/item/' + id + '">item/' + id + '</a>'
        } else if(type === Common.REPORTTYPE_COMMENT) {
            return '<a href="#/comment/' + id + '">comment/' + id + '</a>'
        } else if(type === Common.REPORTTYPE_USER) {
            return '<a href="#/user/' + id + '">user/' + id + '</a>'
        }
    }

    function ignore(report) {
        let reportReview = {
            report_id: report.id,
            decision: Common.ReportReviewDecision_Ignore
        }
        Common.postData('report/review', reportReview)
        .then(r => {
            if(!r.ok) {
                alert("Problem submitting Review")
            } else {
                reports = reports.filter(r => r.id != report.id)
                Common.CreateNotification({body: "Ignored Report."}, 1000)
            }
        })
    }

    function remove(report) {
        let reportReview = {
            report_id: report.id,
            decision: Common.ReportReviewDecision_Delete
        }
        Common.postData('report/review', reportReview)
        .then(r => {
            if(!r.ok) {
                alert("Problem submitting Review")
            } else {
                reports = reports.filter(r => r.id != report.id)
                Common.CreateNotification({body: "Removed Item."}, 1000)
            }
        })
    }

    function banAndIgnore(report) {
        let reportReview = {
            report_id: report.id,
            decision: Common.ReportReviewDecision_Ban
        }
        Common.postData('report/review', reportReview)
        .then(r => {
            if(!r.ok) {
                alert("Problem submitting Review")
            } else {
                reports = reports.filter(r => r.id != report.id)
                Common.CreateNotification({body: "Banned User."}, 1000)
            }
        })
    }
</script>

<div style="padding: 10px;">
    <h2>Reported Content</h2>
    <p>
        The following table contains content reported by other users.
    </p>
</div>
<table>
    <tr>
        <th>Id</th>
        <th>Reported Time</th>
        <th>User</th>
        <th>Link</th>
        <th>Reason</th>
        <th>Actions</th>
    </tr>
    {#each reports as r}
        <tr>
            <td>{r.id}</td>
            <td>{Common.UnixTimeToDateStr(r.createtime)}</td>
            <td><a href={"#/user/" + r.user_id}>user/{r.user_id}</a></td>
            <td>{@html createLink(r.type, r.ref_id)}</td>
            <td>{r.body}</td>
            <td>
                <button on:click={() => remove(r)}>Remove</button>
                <button on:click={() => ignore(r)}>Ignore</button>
                <button on:click={() => banAndIgnore(r)}>Ban User</button>
            </td>
        </tr>
    {/each}
</table>